<template>
  <div class="incomedetail">
    <toptitle :title1="titlework" />

    <section class="income-bt" v-for="(item, index) in subBody" :key="index">
      <p class="detail">
        收入项<span class="companyName">({{ item.COMPANY }})</span>
      </p>
      <div class="income-box">
        <div
          class="income-small"
          v-for="(items, index2) in item.INCOME"
          :key="index2"
        >
          <p v-if="items.DESCR !== '应发工资'">
            <span>{{ items.DESCR }}</span
            ><span>￥{{ items.AMOUNT }}</span>
          </p>
        </div>
        <div class="income-bot" v-if="item.SHOULD.AMOUNT">
          <p>
            应发工资：<span>{{ item.SHOULD.AMOUNT }}</span>
          </p>
        </div>
        <van-empty v-if="emptyShow1" description="暂无收入项" />
      </div>
    </section>
    <section
      class="income-bt"
      v-for="(item, index3) in subBody"
      :key="item + index3"
    >
      <p class="detail koujian">
        扣减项<span class="companyName">({{ item.COMPANY }})</span>
      </p>
      <div class="income-box">
        <div
          class="income-small"
          v-for="(items, index4) in item.DEDUCTION"
          :key="index4"
        >
          <p>
            <span>{{ items.DESCR }}</span
            ><span>￥{{ items.AMOUNT }}</span>
          </p>
        </div>
        <van-empty v-if="emptyShow2" description="暂无扣减项" />
      </div>
      <!-- <div class="income-small" v-if="item.AWARDS != 0">
        <p>
          <span>年终奖</span><span>￥{{ item.AWARDS }}</span>
        </p>
      </div> -->

      <div class="income-bot">
        <p>
          实发工资：<span>{{ item.PAID }}</span>
        </p>
      </div>
    </section>
    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
  import { GetMyIncomeDetailDataApi } from '../request/api';
  import toptitle from '../components/toptitle';
  import LoadingShow from '../components/loading';
  import { decodeUrl, base642String } from '../utils/index';
  export default {
    data() {
      name: 'incomedetail';
      return {
        titlework: '薪酬明细',
        loading: false,
        emptyShow1: false,
        emptyShow2: false,
        timeDay: '',
        //this.$route.query.item
        subBody: []
      };
    },
    computed: {
      //     parmasEmpInfo() {
      //   const pageInfo = JSON.parse(
      //     base642String(decodeUrl(this.$route.query.param))
      //   )
      // //  const pwds = pageInfo.emplid || '' //密码
      // //  return { emplid: emplid }
      // },
    },
    mounted() {
      this.monthSalary();
    },
    methods: {
      monthSalary(val) {
        this.loading = true;
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          CAL_PRD_ID: this.timeDay
        };
        GetMyIncomeDetailDataApi(params).then(res => {
          // res = {
          //   CODE: 200,
          //   MESSAGE: '',
          //   TIME: '2021-07-06 18:24:54.000000',
          //   DATA: [
          //     {
          //       COMPANY: '浙江华峰热塑性聚氨酯有限公司',
          //       INCOME: [
          //         {
          //           SEQNO: '100',
          //           DESCR: '应发工资',
          //           AMOUNT: '10056.7'
          //         },
          //         {
          //           SEQNO: '130',
          //           DESCR: '月标准工资',
          //           AMOUNT: '17274.7'
          //         },
          //         {
          //           SEQNO: '30',
          //           DESCR: 'a工资',
          //           AMOUNT: 'a'
          //         },
          //         {
          //           SEQNO: '',
          //           DESCR: 'b工资',
          //           AMOUNT: 'b'
          //         }
          //       ],
          //       DEDUCTION: [
          //         {
          //           SEQNO: '120',
          //           DESCR: '社保',
          //           AMOUNT: '921.77'
          //         },
          //         {
          //           SEQNO: '108',
          //           DESCR: '基本保障',
          //           AMOUNT: '2100'
          //         }
          //       ],
          //       AWARDS: '0',
          //       PAID: '0'
          //     }
          //   ]
          // };
          if (res.CODE === 200) {
            this.subBody = res.DATA;
            console.log(this.subBody, 'sub');
            this.subBody.forEach(item => {
              item.SHOULD =
                item.INCOME.find(item => {
                  return item.DESCR === '应发工资';
                }) || {};
              item.INCOME.sort((a, b) => {
                // 如果没有 SEQNO 字段，默认排后面
                return !a.SEQNO ? 1 : a.SEQNO - b.SEQNO;
              });
              item.DEDUCTION.sort((a, b) => {
                // 如果没有 SEQNO 字段，默认排后面
                return !a.SEQNO ? 1 : a.SEQNO - b.SEQNO;
              });
              if (item.INCOME.length == 0) {
                this.emptyShow1 = true;
              } else {
                this.emptyShow1 = false;
              }
              if (item.DEDUCTION.length == 0) {
                this.emptyShow2 = true;
              } else {
                this.emptyShow2 = false;
              }
            });
            // if (this.subBody.INCOME.length == 0) {
            //   this.emptyShow1 = true
            // } else {
            //   this.emptyShow1 = false
            // }
            // if (this.subBody.DEDUCTION.length == 0) {
            //   this.emptyShow2 = true
            // } else {
            //   this.emptyShow2 = false
            // }
            this.loading = false;
          }
        });
      }
    },
    components: {
      toptitle,
      LoadingShow
    },
    created() {
      let cal_prd = JSON.parse(this.$route.query.param);
      this.timeDay = cal_prd.CAL_PRD_ID;
    }
  };
</script>

<style lang="less" scoped>
  .income-box {
    border: 1px solid #ccdae5;
    background: #fff;
  }
  .income-small {
    margin: 0 14px;
    border-bottom: 1px solid #e7ecf0;
  }
  .income-small p span:nth-child(1) {
    font-size: 15px;
    color: #747577;
  }
  .income-small:last-child {
    border-bottom: 0;
    padding-bottom: 20px;
  }
  .income-bt {
    margin: 0 14px 10px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 20px;
    .detail {
      // background: #428297;
      line-height: 44px;
      color: #747577;
      font-size: 16px;
      .companyName {
        font-size: 14px;
        color: #999;
      }
    }
    .detail::before {
      display: block;
      width: 32px;
      height: 32px;
      margin-top: 2%;
      margin-right: 2%;
      content: '';
      background: url(../assets/person-salary.png) no-repeat;
      background-size: cover;
    }
    .koujian::before {
      display: block;
      width: 32px;
      height: 32px;
      margin-top: 2%;
      margin-right: 2%;
      content: '';
      background: url(../assets/outer-pay.png) no-repeat;
      background-size: cover;
    }
    div {
      padding: 10px 0px;
      padding-bottom: 0;
    }
    p {
      font-size: 13px;
      color: #8f8f8f;
      line-height: 24px;
      display: flex;
      justify-content: flex-start;
      span {
        display: inline-block;
      }
      span:nth-child(1) {
        width: 60%;
      }
    }
  }
  .income-bot {
    background-color: #007fc6;
    p {
      color: #fff;
      padding: 0 0 7px 10px;
      font-size: 16px;
      span {
        color: #e4fe2b;
      }
    }
  }

  .incomedetail .income-bt:last-child {
    margin-bottom: 20px;
  }
</style>
